// extracted by mini-css-extract-plugin
export var fadeIn = "_my-1";
export var modalContent = "_my-3";
export var overlay = "_my-0";
export var popoverContent = "_my-2";
export var results = "_my-5";
export var searchInputWrapper = "_my-4";